<template>
  <div class="main-conent main-conent-maxheight page-camera-trap">
    <div class="main-content-cols" v-loading="loading">
      <div
        class="main-content-col controllers"
        style="width: 180px;background-color: #f1f1f1"
      >
        <div
          class="camera-trap__dev-btns"
          style="height: 70px"
          :class="{ actived: -1 === actived, disabled: loadingImg }"
          @click="setActive(-1)"
        >
          汇总
        </div>

        <div
          class="camera-trap__dev-btns"
          v-for="(dev, idx) in devs"
          :key="dev.id"
          :class="{ actived: idx === actived, disabled: loadingImg }"
          @click="setActive(idx)"
        >
          <div class="camera-trap__dev-btns-rows">
            <el-tag
              :type="dev.category === 1 ? 'success' : 'warning'"
              class="category"
            >
              {{ getCategory(dev.category) }}
            </el-tag>
            <div class="">
              {{ dev.name }}
            </div>
          </div>

          <div class="camera-trap__dev-btns-rows">
            <div class="tips">最新: {{ dev.last }}</div>
          </div>
          <div class="camera-trap__dev-btns-rows">
            <div class="tips">今日: {{ dev.count }}</div>
          </div>
        </div>
      </div>

      <div class="main-content-col imgs-content">
        <search
          v-if="!loading"
          :loading="loadingImg"
          :type="type"
          @date-change="goSearch"
          @type-change="typeChange"
          @export-excel="exportExcel"
        />

        <div class="cols">
          <div class="col" style="flex: 3;overflow:hidden;">
            <transition name="slide-right">
              <div v-show="type === 'chart'" class="move-container" key="chart">
                <div
                  class="col"
                  style="height:200px;background-color: #fff;box-shadow: 0 1px 4px #d1d1d1;"
                >
                  <chart
                    :data="analyse"
                    :devs="devs"
                    :insects="insects"
                    :actived="actived"
                  />
                </div>

                <div class="col">
                  <div class="imgs-wrap">
                    <img-list
                      :loading="loadingImg"
                      :data="filterImgs"
                      @show-model="showModel"
                    />
                  </div>

                  <div class="paging">
                    <el-pagination
                      background
                      layout="total, prev, pager, next"
                      :total="paging.total"
                      :page-size="paging.limit"
                      :current-page="paging.page"
                      :disabled="loadingImg"
                      @current-change="goPage"
                    >
                    </el-pagination>
                  </div>
                </div>
              </div>
            </transition>

            <transition name="slide-left">
              <div v-show="type === 'table'" class="move-container" key="table">
                <ntable
                  ref="table"
                  :data="analyse"
                  :insects="insects"
                  :devs="devs"
                  :device="device"
                />
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import showDetail from './model'
import { getGeoJson } from '@/service/site'
import * as api from '@/service/cameraTrap'
import moment from 'moment'
import sleep from '@/utlis/sleep'
import Search from './Search'
import ImgList from './ImgList'
import Chart from './Chart'
// import Nmap from './map'
import Ntable from './Table'
import _ from 'lodash'

export default {
  components: { Search, ImgList, Chart, Ntable },
  data() {
    return {
      loading: true,
      loadingImg: false,
      loadingAnalyse: false,
      sites: [],
      devs: [],
      actived: -1,
      imgs: [],
      cates: [],
      paging: { page: 1, limit: 21, total: 0 },
      analyse: [],
      origData: [],
      geoJson: {},
      type: 'chart',
      begin: null,
      end: null
    }
  },
  computed: {
    device() {
      return this.devs[this.actived] || {}
    },
    filterImgs() {
      return this.device && this.device.id
        ? this.imgs.filter(i => i.deviceId === this.device.id)
        : this.imgs
    },
    total() {
      return this.filterImgs.length
    },
    insects() {
      if (this.device && this.device.id) {
        let row = this.origData.find(o => o.deviceId === this.device.id)
        return row ? row.insects : []
      } else {
        return _.uniqBy(_.flatten(this.origData.map(a => a.insects)), 'id')
      }
    }
  },
  mounted() {
    this.getSites()
  },
  methods: {
    async getSites() {
      try {
        this.loading = true
        const [devs, last, geo] = await Promise.all([
          api.device(this.companyId),
          api.last(this.companyId),
          getGeoJson(this.companyId),
          sleep(1)
        ])

        this.devs = devs.data.map(d => {
          let l = last.data.find(ll => d.id === ll.id) || { last: '', count: 0 }
          return { ...d, last: l.last, count: l.count }
        })
        // this.last = last.data
        this.geoJson = geo
      } catch (e) {
        console.log(e)
        this.$message.error(e)
      } finally {
        this.loading = false
      }
    },
    async getData(begin, end, page, limit) {
      try {
        this.loadingImg = true
        const [{ data }] = await Promise.all([
          api.imgs(
            { companyId: this.companyId, deviceId: this.device.id, begin, end },
            page,
            limit
          ),
          sleep(0.5)
        ])
        this.imgs = data.data.map(im => ({
          ...im,
          thumb: `${im.origImg.replace(
            'origPic',
            'thumbPic'
          )}?x-image-process=image/resize,m_lfit,h_200,w_200`
        }))
        this.paging.total = data.paging.total
        this.paging.page = page
      } catch (e) {
        console.log(e)
        this.$message.error(e)
      } finally {
        this.loadingImg = false
      }
    },
    async getAnalyse(begin, end) {
      try {
        this.loadingAnalyse = true
        const [{ data }] = await Promise.all([
          api.analyse(this.companyId, begin, end),
          sleep(0.5)
        ])
        this.origData = data
        this.analyse = this.format(data, begin, end)
        // this.insects = insects
      } catch (e) {
        console.log(e)
        this.$message.error(e)
      } finally {
        this.loadingAnalyse = false
      }
    },
    format(analyse, begin, end) {
      let e = moment(end)
      let b = moment(begin).subtract(1, 'day')
      let data = []

      for (let i = b; i.isBefore(e); i.add(1, 'day')) {
        let day = i.format('YYYY-MM-DD')
        day = moment(day)
          .add(1, 'days')
          .format('YYYY-MM-DD')

        let obj = { day, count: 0 }

        obj.devices = this.devs.map(d => {
          let oo = { id: d.id, name: d.name, count: 0, insects: [] }
          let item = analyse.find(a => a.day === day && a.deviceId === d.id)
          // console.log(d.name, day, item)

          if (item) {
            oo.insects = item.insects
            oo.count = _.sumBy(item.insects, 'count')
            obj.count += oo.count
          }
          return oo
        })

        data.push(obj)
      }
      return data
    },
    goSearch(begin, end) {
      this.begin = begin
      this.end = end
      this.getData(begin, end, 1, this.paging.limit)
      this.getAnalyse(begin, end)
    },
    setActive(idx) {
      if (this.loadingImg) return
      this.actived = idx
      this.getData(this.begin, this.end, 1, this.paging.limit)
    },
    showModel(im) {
      showDetail({
        id: im.predImg ? null : im.gatherId,
        src: im.predImg || im.origImg,
        title: `[${im.device}] - ${moment(im.createdAt).format(
          'YYYY-MM-DD HH:mm:ss'
        )}`,
        insects: im.insects
      })
    },
    goPage(page) {
      this.getData(this.begin, this.end, page, this.paging.limit)
    },
    typeChange(v) {
      this.type = v
    },
    getCategory(id) {
      return ['', '性诱', '色诱'][id]
    },
    exportExcel() {
      let dev = this.device.name || '汇总'
      let title = `性诱色诱-${dev}-${this.begin}-${this.end}`
      this.$refs.table.exportExcel(title)
    }
  },
  watch: {
    actived(idx) {
      if (idx > -1) {
        this.$refs.map && this.$refs.map.setFocus(this.devs[idx].id)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.controllers {
  padding: 0;
  box-sizing: border-box;
  border-right: 1px dashed #d1d1d1;
  overflow-y: auto;
  overflow-x: hidden;
}
.camera-trap__dev-btns {
  text-align: center;
  padding: 0;
  height: 88px;
  box-sizing: border-box;
  box-shadow: 0 0 1px #000;
  background-color: #fff;
  cursor: pointer;
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  &.actived {
    color: #209e91;
    background-color: rgba(160, 207, 255, 0.3);
  }
  &.disabled {
    // background-color: #e4e7ed;
    cursor: wait;
    pointer-events: none;
  }
  &:hover {
    box-shadow: -1px -1px 2px #000 inset, 1px 2px 2px #000;
  }
  &:active {
    box-shadow: 1px -1px 4px #000 inset, 1px -1px 2px #000;
  }
  .camera-trap__dev-btns-rows {
    padding: 2px 8px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    text-align: left;
    box-sizing: border-box;
    .category {
      margin-right: 8px;
    }
  }
  .tips {
    color: #909399;
    font-size: 12px;
    margin-top: 4px;
    word-spacing: 0;
    letter-spacing: 0;
  }
}

.imgs-content {
  display: flex;
  flex-direction: column;
  flex: 2;
  background-color: #f1f1f1;
}
.imgs-wrap {
  flex: 1;
  overflow: hidden;
}
.cols {
  display: flex;
  overflow: hidden;
  flex: 1;
}
.col {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  overflow: hidden;
  &:not(:last-child) {
    border-bottom: 1px dashed #d1d1d1;
  }
}
.move-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 1px #000;
  overflow: hidden;
  will-change: transform; /* 提示浏览器提前优化 */
  backface-visibility: hidden; /* 防止闪烁 */
}
</style>

<style>
.imgs-content .images-list {
  height: 100%;
  overflow: auto;
}
</style>
